/**
 * 组织组件实体
 * zxw
 * 创建时间：
 * 更新时间：2026-08-19
 * 更新内容：添加主副LOGO
 */

import CNF from '../../incs/Config';
import { useState, useEffect } from 'react';
import {
    Flex,
    Modal,
    Input,
    Row,
    Col,
    message,
    Typography,
    Upload,
    Image,
} from 'antd';
import {
    PlusOutlined,
} from '@ant-design/icons';
import $ from 'jquery';
import {
    AddRequestHeaders,
    AliyunOSSclient,
    AliyunOSSDelete,
    uploadImageButton,
    GetBase64,
    UjoinParams,
    uuid,
} from '../../incs/FunHelper';


const MODULENAME = '组织信息';

const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [prefix, setPrefix] = useState('');
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [fileList1, setFileList1] = useState([]);    // 主LOGO
    const [fileList2, setFileList2] = useState([]);    // 副LOGO
    const [previewOpen, setPreviewOpen] = useState(false); //  图片预览是否打开
    const [previewImage, setPreviewImage] = useState(''); //  图片预览资源
    const [description, setDescription] = useState('');

    const resetAndClose = () => {
        props.setOpen(false);
        setLoading(false);
        setPrefix('');
        setName('');
        setAddress('');
        setDescription('');
        setFileList1([]);
        setFileList2([]);
    };

    // 用户取消操作（含删除图片）
    const handleCancel = () => {
        // 清理主LOGO新文件
        fileList1.forEach(file => {
            if (file.isNew && file.path) {
                AliyunOSSDelete(file);
            }
        });

        // 清理副LOGO新文件
        fileList2.forEach(file => {
            if (file.isNew && file.path) {
                AliyunOSSDelete(file);
            }
        });
        resetAndClose();
    };


    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setPrefix(props.record.prefix);
            setName(props.record.name);
            setAddress(props.record.address);
            // 主LOGO
            if (props.record.icon_brand_url) {
                setFileList1([{
                    uid: 1,
                    url: props.record.icon_brand_url,
                    preview: props.record.icon_brand_url,
                    status: 'done',
                    percent: 100,
                    isNew: false,
                }]);
            } else {
                setFileList1([]);
            }

            // 副LOGO
            if (props.record.icon_slogan_url) {
                setFileList2([{
                    uid: 2,
                    url: props.record.icon_slogan_url,
                    preview: props.record.icon_slogan_url,
                    status: 'done',
                    percent: 100,
                    isNew: false,
                }]);
            } else {
                setFileList2([]);
            }
            setDescription(props.record.description);
        }
    }, [props.record]);

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const handlePreview = (file) => {
        if (!file.preview) {
            if (file.originFileObj) {
                //  转换图片，用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        setPreviewImage(file.preview || file.url);
        setPreviewOpen(true);
    }

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        //  判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            messageApi.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 204800) {
            messageApi.error('上传图片超过200KB，请重新上传！', CNF.messageDuration);
            return false;
        }
        return true;
    }

    /**
     * 通用上传到阿里云 OSS
     * @param {File} file
     * @param {Function} setFileList
     * @param {Array} fileList
     */
    const aliyunOSSUpload = (file, setFileList, fileList) => {
        const headers = {
            //  文件acl授权为公共读
            'x-oss-object-acl': 'public-read'
        }

        const params = {
            acl: 'PutObject',
        }

        // 手动添加文件到列表，标记为新文件
        const newFile = {
            uid: file.uid,
            name: file.name,
            status: 'uploading',
            percent: 0,
            url: '',
            path: '',
            isNew: true,
            originFileObj: file,
        };

        setFileList(prev => [...prev, newFile]);

        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',
            success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = () => {
                        //  路径由以下部分组成
                        //  项目代码+avatar+组织前缀+uuid+附件名（去除空格）
                        let path = CNF.projectCode.toLowerCase()
                        path += '/orgs';
                        path += '/' + props.preGroup;
                        path += '/' + uuid;
                        path += '/' + file.name.replace(/\s/g, '');
                        AliyunOSSclient(token).multipartUpload(path, file,
                            {
                                // 请求头
                                headers,
                                // 获取分片上传进度、断点和返回值
                                progress: (p) => {
                                    setFileList(prev =>
                                        prev.map(item =>
                                            item.uid === file.uid
                                                ? {
                                                    ...item,
                                                    percent: parseInt(p * 100),
                                                    status: p === 1 ? 'done' : 'uploading',
                                                    url: CNF.ossApi + path,
                                                    path: path,
                                                }
                                                : item
                                        )
                                    );
                                },
                                // 分片数量
                                parallel: Math.ceil(file.size / 1024 / 1024),
                                // 设置分片大小，默认为1M。
                                partSize: 1024 * 1024,
                                mime: "text/plain",
                            }).then((result) => {
                                //  上传成功
                                if (result.res.status === 200) {
                                }
                            }).catch((e) => {
                                //  上传失败
                                messageApi.error(file.name + ' 上传失败！', CNF.messageDuration);
                                setFileList(prev => prev.filter(item => item.uid !== file.uid));
                            });
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            },
            error: function () {
                messageApi.error('获取STS Token失败！', CNF.messageDuration);
            }
        });
    }

    /**
     * 移除文件（用户点击删除按钮）
     */
    const handleRemove = (file, setFileList, fileList) => {
        if (file.isNew && file.path) {
            AliyunOSSDelete(file);
            setFileList(prev => prev.filter(item => item.uid !== file.uid));
        } else if (!file.isNew) {
            // 旧文件仅从列表中移除，OSS文件保留
            setFileList(prev => prev.filter(item => item.uid !== file.uid));
        } else {
            setFileList(prev => prev.filter(item => item.uid !== file.uid));
        }
    };

    const ok = () => {
        if (!prefix) {
            messageApi.error('前缀不能为空！');
            return;
        }
        if (!name) {
            messageApi.error('名称不能为空！');
            return;
        }

        setLoading(true);

        const params = {
            prefix,
            name,
            address,
            icon_brand_url: fileList1.length > 0 ? fileList1[0].url : '',
            icon_slogan_url: fileList2.length > 0 ? fileList2[0].url : '',
            description,
        };

        $.ajax({
            url: CNF.api + 'orgs/infos' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify(params),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    resetAndClose();
                    props.refresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON?.detail || '保存失败', CNF.messageDuration);
            setLoading(false);
        }).always(() => setTimeout(function () {
            setLoading(false);
        }, CNF.messageDuration * 1000))
    };

    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={handleCancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>前缀</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setPrefix(e.target.value)}
                                value={prefix}
                                disabled={props.record ? true : false}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>名称</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>地址</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setAddress(e.target.value)}
                                value={address}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>品牌图标</Text></Col>
                        <Col span={11} offset={2}><Text>标语图标</Text></Col>
                        <Col span={11}>
                            <Upload
                                listType='picture-card'
                                beforeUpload={(file) => {
                                    if (beforeUpload(file)) {
                                        aliyunOSSUpload(file, setFileList1, fileList1);
                                    }
                                    return false;
                                }}
                                style={{ padding: 0 }}
                                icon={<PlusOutlined />}
                                customRequest={() => { }}
                                fileList={fileList1}
                                disabled={loading}
                                onPreview={handlePreview}
                                onRemove={(file) => handleRemove(file, setFileList1, fileList1)}
                            >
                                {fileList1.length > 0 ? null : uploadImageButton}
                            </Upload>
                        </Col>
                        <Col span={11} offset={2}>
                            <Upload
                                beforeUpload={(file) => {
                                    if (beforeUpload(file)) {
                                        aliyunOSSUpload(file, setFileList2, fileList2);
                                    }
                                    return false;
                                }}
                                listType='picture-card'
                                style={{ padding: 0 }}
                                icon={<PlusOutlined />}
                                customRequest={() => { }}
                                fileList={fileList2}
                                onPreview={handlePreview}
                                onRemove={(file) => handleRemove(file, setFileList2, fileList2)}
                            >
                                {fileList2.length > 0 ? null : uploadImageButton}
                            </Upload>
                        </Col>
                        {previewImage && (
                            <Image
                                wrapperStyle={{
                                    display: 'none',
                                }}
                                preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) => setPreviewOpen(visible),
                                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                }}
                                src={previewImage}
                            />
                        )}
                    </Row>
                    <Row>
                        <Col span={24}><Text>描述</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 3, maxRows: 5 }}
                                onChange={(e) => setDescription(e.target.value)}
                                value={description}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity